module.exports = __webpack_public_path__ + "assets/img/38d6-km.svg";